import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UserCard} from '~local/app/types/UserCard';
import {Observable} from 'rxjs';
import {Account} from './../../types/Account';
import {UserProfile} from './../../types/UserProfile';
import {DataSourceResponse, DataSourceService} from './DataSourceService';

interface CardInfo {
    cardInfo: UserCard;
    userProfile: UserProfile;
    account: Account;
}

@Injectable()
export class CardsService extends DataSourceService<UserCard> {
    constructor(private readonly http: HttpClient) {
        super();
    }

    public loadData(
        filter: string = '',
        orderBy: string = '',
        orderDirection: string = 'ASC',
        pageNumber: number = 0,
        pageSize: number = 10
    ): Observable<DataSourceResponse<UserCard>> {
        return this.http.get<DataSourceResponse<UserCard>>('/admin/cards/list/', {
            params: new HttpParams()
                .set('filter', filter)
                .set('orderBy', orderBy)
                .set('sort', orderDirection.toUpperCase())
                .set('skip', pageNumber.toString())
                .set('take', pageSize.toString())
        });
    }

    public getAllCards(): Observable<UserCard[]> {
        return this.http.get<UserCard[]>('/admin/cards/list/');
    }

    public getCard(id: number): Observable<CardInfo> {
        return this.http.get<CardInfo>('/admin/cards/' + id);
    }

    public rejectCard(formData: any): Observable<any> {
        return this.http.post<any>('/admin/cards/reject', formData);
    }

    public approveCard(formData: any): Observable<any> {
        return this.http.post<any>('/admin/cards/approve', formData);
    }
}
